// extracted by mini-css-extract-plugin
export default {"List":"Awards_List__LhbXH","Item":"Awards_Item__+0GUq","Logo":"Awards_Logo__vKO2Z","Name":"Awards_Name__cDN4z"};